export var getActionButtonColors = function (variant, loading) {
    if (loading)
        return { variant: 'action-loading' };
    switch (variant) {
        case 'error': {
            return { variant: 'action-error' };
        }
        case 'success': {
            return { variant: 'action-success' };
        }
        case 'incomplete': {
            return { variant: 'action-incomplete' };
        }
        case 'selected': {
            return { variant: 'action-selected' };
        }
        default: {
            return { variant: 'action-default' };
        }
    }
};
